import Cookies from 'js-cookie'

let currentCookies = null

const getAllCookies = () => {
  return Cookies.get();
}

const removeCookie = (name) => {
  // Removal only works when domain and path match how the cookie
  // was set (e.g. "_ga" uses domain=.example.com), so try every
  // combination visible from the current page
  const domains = [undefined];
  const hostParts = window.location.hostname.split(".");
  for (let i = 0; i < hostParts.length - 1; i++) {
      domains.push(hostParts.slice(i).join("."));
  }

  const paths = ["/"];
  let path = "";
  for (const segment of window.location.pathname.split("/").filter(Boolean)) {
    path += `/${segment}`;
    paths.push(path, `${path}/`);
  }

  domains.forEach((domain) => {
      paths.forEach((path) => {
          Cookies.remove(name, domain ? { path, domain } : { path });
      });
  })
}

const getAccCookies = () => {
  // if cookies set already, return. if cookies set and empty, return false.
  if (currentCookies && Object.entries(currentCookies).length > 0) return currentCookies
  if (currentCookies && Object.entries(currentCookies).length === 0) return false

  currentCookies = JSON.parse(Cookies.get(getAccCookieKey()) || '{}')

  return Object.entries(currentCookies).length > 0 ? currentCookies : false
}

const setAccCookies = (cookies) => {
  currentCookies = cookies

  Cookies.set(getAccCookieKey(), JSON.stringify(cookies), {
    path: '/',
    expires: 30, // in days
    sameSite: true,
  })
}

const getAccCookieKey = () => {
  const gdpr = document.querySelector('#GdprConsent');
  const id = gdpr.dataset.gdprId;
  const version = gdpr.dataset.gdprVersion;
  return 'accc-' + id + '-' + version;
}

export default {}
export {
  getAllCookies,
  removeCookie,
  getAccCookies,
  setAccCookies,
  getAccCookieKey,
}
